import {Cureus} from '../Cureus';

Cureus.FeaturedArticles = {};
//= require_tree ./FeaturedArticles